import { render, staticRenderFns } from "./DebtInfo.vue?vue&type=template&id=20a4de20&"
import script from "./DebtInfo.vue?vue&type=script&lang=js&"
export * from "./DebtInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports